import React, {useState, useEffect} from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from "./Alert";

export default function MaterialSnackBar(props) {

    let {open, onSnackClosed, message, severity, ...others} = props;
    const [openSnack, setOpenSnack] = useState(open);
    const snackClosedCallback = onSnackClosed;
    if (severity == null) {
        severity = "error";
    }
    const handleSnackClose = (reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
        snackClosedCallback();
    };

    useEffect(() => {
        setOpenSnack(open);
    }, [open]);

    return (
        <Snackbar open={openSnack}
                  autoHideDuration={3000}
                  onClose={handleSnackClose}
                  {...others}>
            <Alert onClose={handleSnackClose}
                   severity={severity}>
                {message}
            </Alert>
        </Snackbar>
    );

}